import { axios } from '@/plugins/axios';
import { CurrencyRate } from '@/models/currency';

export class CurrencyService {
  private endpoint: string;

  constructor() {
    this.endpoint = 'v1/currencies/';
  }

  async fetchCurrencies() {
    return axios
      .get<CurrencyRate[]>(`${this.endpoint}rates/`)
      .then(({ data }) => data);
  }

  async fetchCurrency(id: number) {
    return axios
      .get<CurrencyRate>(`${this.endpoint}${id}/rates/`)
      .then(({ data }) => data);
  }

  async updateCurrencyExchangeRateRate(id: number, rate: number) {
    return axios
      .post<CurrencyRate>(`${this.endpoint}${id}/rates/set_current_rate/`, {
        rate
      })
      .then(({ data }) => data);
  }

  async createCurrency({
    code,
    description
  }: {
    code: string;
    description: string;
  }) {
    return axios
      .post<CurrencyRate>(`${this.endpoint}/`, { code, description })
      .then(({ data }) => data);
  }
}
